/**
 * Одна пометка над плитками вместо «частично» на каждой: причина человеческим текстом (см. `collapsePartialTiles`).
 */

import { CircleAlert } from 'lucide-react'
import { cn } from '../../../lib/cn'

export function QualityNote({ reason, className, testId = 'tiles-quality-note' }: { reason: string; className?: string; testId?: string }) {
  return (
    <p
      role="note"
      data-testid={testId}
      className={cn('flex items-start gap-1.5 rounded-lg bg-yellow-50 px-3 py-2 text-xs text-yellow-900 dark:bg-yellow-950/30 dark:text-yellow-200', className)}
    >
      <CircleAlert className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>
        Все показатели посчитаны частично. {reason}
      </span>
    </p>
  )
}

export default QualityNote
